import { AttachmentDetails } from 'owa-addins-core';
import { AttachmentState } from 'owa-attachment-full-data';
import getAttachment from 'owa-attachment-model-store/lib/selectors/getAttachment';
import { AttachmentWellViewState } from 'owa-attachment-well-data';
import { isCloudyAttachmentType } from 'owa-attachment-model-store/lib/utils/isCloudyAttachment';

export const FILE_ATTACHMENT_TYPE: string = 'FileAttachment:#Exchange';
export const ITEM_ATTACHMENT_TYPE: string = 'ItemAttachment:#Exchange';
export const ITEM_ID_ATTACHMENT_TYPE: string = 'ItemIdAttachment:#Exchange';
export const REFERENCE_ATTACHMENT_TYPE: string = 'ReferenceAttachment:#Exchange';

export enum TypeOfAttachment {
    File = 0,
    Item = 1,
    Cloud = 2,
}

export default function getAllAttachments(
    attachmentWell: AttachmentWellViewState
): AttachmentDetails[] {
    const attachmentData: AttachmentDetails[] = [];
    if (attachmentWell) {
        if (attachmentWell.inlineAttachments) {
            attachmentWell.inlineAttachments.forEach(attachment => {
                var attachmentDetail: AttachmentDetails = getAttachmentDetails(attachment);
                attachmentData.push(attachmentDetail);
            });
        }
        if (attachmentWell.docViewAttachments) {
            attachmentWell.docViewAttachments.forEach(attachment => {
                var attachmentDetail: AttachmentDetails = getAttachmentDetails(attachment);
                attachmentData.push(attachmentDetail);
            });
        }
        if (attachmentWell.imageViewAttachments) {
            attachmentWell.imageViewAttachments.forEach(attachment => {
                var attachmentDetail: AttachmentDetails = getAttachmentDetails(attachment);
                attachmentData.push(attachmentDetail);
            });
        }
    }
    return attachmentData;
}

export function getTypeOfAttachment(attachmentType: string): TypeOfAttachment {
    switch (attachmentType) {
        case FILE_ATTACHMENT_TYPE:
            return TypeOfAttachment.File;
        case ITEM_ATTACHMENT_TYPE:
            return TypeOfAttachment.Item;
        case REFERENCE_ATTACHMENT_TYPE:
            return TypeOfAttachment.Cloud;
        default:
            throw new Error(`Invalid type of attachment ${attachmentType}`);
    }
}

export function getAttachmentDetails(attachment: AttachmentState): AttachmentDetails {
    var url = undefined;
    const attachmentModel = getAttachment(attachment.attachmentId);
    if (attachmentModel?.model) {
        if (isCloudyAttachmentType(attachmentModel.model)) {
            url = attachmentModel.model.AttachLongPathName;
        }
        var attachmentDetail: AttachmentDetails = {
            id: attachment.attachmentId.Id,
            name: attachmentModel.model.Name,
            contentType: attachmentModel.model.ContentType,
            size: attachmentModel.model.Size,
            attachmentType: getTypeOfAttachment(attachmentModel.model.__type),
            isInline: attachmentModel.model.IsInline,
            url: url,
        };
    }
    return attachmentDetail;
}
